module.exports = __webpack_public_path__ + "static/media/dito.74715d03.gif";